import React, { Component } from 'react';
import { CardTitle, Label, Button, Alert } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

import appFunctions from '../../services/Functions';

import IntlMessages from '../../helpers/IntlMessages';
import { injectIntl } from 'react-intl';

class CodeNew extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: '',
    };
  }

  onUserCode = async (values, setSubmitting) => {
    try {
      const { newPassword } = values;
      const { code, resetSuccess } = this.props;

      await appFunctions.activateAccount({
        code,
        password: newPassword,
      });

      await resetSuccess(newPassword);

      setSubmitting(false);
    } catch (err) {
      const { messages } = this.props.intl;

      setSubmitting(false);

      this.setState({
        error: `${messages['user.GeneralException']} ${err.message}`,
      });

      console.error(err.code);
    }
  };

  // Render
  render() {
    const { messages } = this.props.intl;
    const { error } = this.state;

    return (
      <Formik
        initialValues={{ newPassword: '', newPasswordConfirm: '' }}
        validationSchema={Yup.object().shape({
          newPassword: Yup.string()
            .required(messages['forms.validation.password.required'])
            .min(6, messages['forms.validation.password.weak']),
          newPasswordConfirm: Yup.string().equals(
            [Yup.ref('newPassword')],
            messages['forms.validation.password.confirmation.required']
          ),
        })}
        onSubmit={(values, { setSubmitting }) => {
          this.onUserCode(values, setSubmitting);
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <NavLink to="/user/login" className="d-block mb-4">
              <i className="iconsminds-arrow-out-left" />
              <IntlMessages id="user.login.page" />
            </NavLink>

            <CardTitle className="mb-4">
              <IntlMessages id="user.new-password" />
            </CardTitle>

            <p className="mb-4">
              <IntlMessages id="user.new-password_desc" />
            </p>

            {error && (
              <Alert color="danger" className="mt-2 mb-2">
                {error}
              </Alert>
            )}

            <Label className="form-group has-top-label mb-4">
              <Field
                type="password"
                name="newPassword"
                className="form-control"
              />
              <IntlMessages id="user.new_password" />
              <ErrorMessage
                name="newPassword"
                component="div"
                className="invalid-feedback d-block"
              />
            </Label>

            <Label className="form-group has-top-label mb-4">
              <Field
                type="password"
                name="newPasswordConfirm"
                className="form-control"
              />
              <IntlMessages id="user.new_password_confirm" />
              <ErrorMessage
                name="newPasswordConfirm"
                component="div"
                className="invalid-feedback d-block"
              />
            </Label>

            <div className="d-flex justify-content-end align-items-center">
              <Button
                type="submit"
                color="primary"
                outline
                size="lg"
                disabled={isSubmitting}
              >
                <IntlMessages id="forms.action.reset" />
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}

export default injectIntl(CodeNew);
